import React from "react";

/**
 * Catches render-time errors anywhere in the child tree so a single broken
 * component (e.g. a CMS article missing an expected media field) can no longer
 * unmount the whole app and leave users staring at a black screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface in the browser console / Sentry (already wired in the app).
    console.error("ErrorBoundary caught an error:", error, info);
  }

  componentDidUpdate(prevProps) {
    // Recover on client-side navigation: once the route changes, clear the
    // error so the next page renders instead of the fallback sticking around.
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div
          style={{
            minHeight: "60vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "2rem",
            color: "#fff",
          }}
        >
          <h2>Something went wrong.</h2>
          <p style={{ opacity: 0.7, marginTop: "0.5rem" }}>
            Please try reloading the page.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: "1.5rem",
              padding: "0.6rem 1.4rem",
              cursor: "pointer",
            }}
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
